import React, { useState, useEffect } from 'react';
import coreXTextImage from '../images/CorexasLogoWithoutText.png';
import backgroundImage from "../images/Background.png";
import styles from './IntroPages.module.css';
import { useParams } from 'react-router-dom';
import { getText } from '../languageutil/translations';
import { getLanguageBasedImage } from '../languageutil/ImageUtil';

const INITIAL_ROUTES = {
  tr: {
    innovation: '/quiz/innovation/ProblemAnaBoyut.json/PROBLEM',
    technology: '/quiz/technology/OperasyonAnaBoyut.json/OPERASYON',
    sustainability: '/quiz/sustainability/OperasyonAnaBoyut.json/OPERASYON',
    strategy: '/quiz/strategy/StratejiAnaBoyut.json/STRATEJİ'
  },
  en: {
    innovation: '/quiz/innovation/ProblemAnaBoyut-en.json/PROBLEM',
    technology: '/quiz/technology/OperasyonAnaBoyut-en.json/OPERATION',
    sustainability: '/quiz/sustainability/OperasyonAnaBoyut-en.json/OPERATION',
    strategy: '/quiz/strategy/StratejiAnaBoyut-en.json/STRATEGY'
  }
};

function QuizStarterPage({ navigate }) {
    const { quizType } = useParams();
    const [quizName, setQuizName] = useState("");
    const [startButtonImage, setStartButtonImage] = useState(null);

    useEffect(() => {
        setStartButtonImage(getLanguageBasedImage('BaslaButton.png'));
    }, []);

    useEffect(() => {
        switch (quizType) {
            case "innovation":
                setQuizName(getText('innovationTitle'));
                break;
            case "technology":
                setQuizName(getText('technologyTitle'));
                break;
            case "sustainability":
                setQuizName(getText('sustainabilityTitle'));
                break;
            case "strategy":
                setQuizName(getText('strategyTitle'));
                break;
            default:
                break;
        }
    }, [quizType]);

    const handleBasla = async () => {
        const language = localStorage.getItem('language') || 'tr';
        const route = INITIAL_ROUTES[language][quizType];
        
        const companyName = localStorage.getItem('companyName');
        try {
            const response = await fetch(`https://corexas-analysis-backend-i1q0.onrender.com/api/progress/${encodeURIComponent(companyName)}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: localStorage.getItem('jwt'),
                },
                body: JSON.stringify({
                    latestVisitedRoute: route,
                    language
                }),
            });
            if (!response.ok) {
                console.error('Failed to update progress.');
            }
        } catch (error) {
            console.error('Error updating progress:', error);
        }

        navigate(route);
    };

    return (
        <div className={styles.intropage} style={{ backgroundImage: `url(${backgroundImage})`, backgroundRepeat: "no-repeat", backgroundSize: "cover", backgroundPosition: "center", fontFamily: "Bookman Old Style", flexDirection: "column" }}>
            <div className={styles.content} style={{}}>
                <div className={styles.leftside} style={{ paddingLeft: "2vw", paddingTop: "5vh", flexDirection: "row", display: "flex", justifyItems: "center" }}>
                    <img src={coreXTextImage} alt="CoreXFuture" style={{ height: "16vh", alignSelf: "center" }} />
                    <h2 style={{ fontFamily: "Bookman Old Style", fontSize: "7vh", paddingBottom: "1vh", paddingLeft: "1vw", color: "#c4eff7", whiteSpace: "pre-wrap", textAlign: "left" }}>{quizName}</h2>
                </div>
                <div className={styles.rightside} style={{}}>
                    <div className={styles.buttoncontainer} style={{}} >
                        <img
                            src={startButtonImage}
                            alt={getText('startQuiz')}
                            className={styles.startbutton}
                            onClick={handleBasla}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default QuizStarterPage;